
import { mixins, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import MTokenCartDelete from '@/components/shopify/MTokenCartDelete.vue';
import CheckoutWidgetMixin from '@/mixins/checkoutWidget';

@Options({
  components: {
    MTokenCartDelete
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  }
})
export default class MTokenCartItemDelete extends mixins(CheckoutWidgetMixin) {
  readonly campaignId: string;
  // readonly shopifyCartItemProductId: string;
  // readonly shopifyCartItemVariantId: string;
  // readonly shopifyCartItemTokenAddress: string;
  // readonly shopifyCartItemTokenId: string;

  showDelete = false;

  @Watch('state.storedShopifyCart')
  async cartItemsWatcher(_value: any, _oldValue: any) {
    // const savedCart = this.state.storedShopifyCart;
    // Only show delete if there is no pending draft order
    this.showDelete =
      this.showDelete ||
      (this.state.storedShopifyCart && !this.state.storedShopifyCart.pendingDraftOrder);
  }

  get token() {
    return {
      tokenId: this.shopifyCartItemTokenId,
      contractAddress: this.shopifyCartItemTokenAddress
    };
  }
}
